import {Button, Col, ConfigProvider, Layout, message, Pagination, Popconfirm, Row, Statistic, Table} from 'antd';
import { Content } from 'antd/lib/layout/layout';

import React, { useEffect, useRef, useState } from "react";
import OAMSider from '../oam-sider';
import Cookies from 'js-cookie';
import { sendHttpPostRequest } from '../../../api/http-request';
import Search from 'antd/lib/input/Search';
import zhCN from 'antd/lib/locale/zh_CN';

import idataCourseTableStyles from "../../common/global-styles/idatacourse-table.module.less";

const channelMap = new Map([['爱数科', 1], ['爱数课', 2]]);

export interface Props {}

export const OAMVideoList: React.FC<Props> = (props) => {
    const [videoResult, setVideoResult] = useState([] as any[]);  // 当前显示的结果页

    const [resultSum, setResultSum] = useState(0);  // 搜索返回的结果数
    const [totalCount, setTotalCount] = useState(0);  // 搜索返回的结果数
    const [onlineCount, setOnlineCount] = useState(0);  // 搜索返回的结果数
    const queryContent = useRef('');  // 记录搜索串
    const order = useRef('');  // 排序升序降序
    const order_by = useRef('');  // 排序列
    const page = useRef(1);  // 记录当前的页数
    const pageSize = useRef(10);  // 记录当前每页展示数量
    const sexFilters = useRef([]);  // 性别过滤选项
    const channelFilters = useRef([]);  // 渠道过滤项
    const userIsLogin = useRef(false);  // 用户是否登录

    useEffect(() => {
        queryVideoList();
    }, [])

    // 查询用户列表
    const queryVideoList = () => {
        const sessionid = Cookies.get("sessionid");
        const queryData = {
            query: queryContent.current,
            page: page.current,
            pagesize: pageSize.current,
            order: order.current,
            order_by: order_by.current,

            //sex: JSON.stringify(sexFilters.current),
            //channel: JSON.stringify(channelFilters.current),

            sessionid: sessionid,
            sid: sessionid,
        };
        sendHttpPostRequest(
            'video/api/oam_query_lecture_list/',
            queryData,
            queryVideoListCallback
        )
    }

    const queryVideoListCallback = (response:any) => {
        // console.log(response);
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=user_list';
        } else if (response.code == 0) {
            // 成功
            setVideoResult(response.query_list);

            setResultSum(response.total_sum);
            setTotalCount(response.total_count);
            setOnlineCount(response.online_count);
        } else if (response.code == -501) {
            // 权限不足
            window.location.href = '/oam_login?next=user_list';
        } else {
            message.error(response.message);
        }
    }

    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
       
    }

   
     //点击了查看按钮
  const onLookOverBtnClick = (event:any) => {
    //message.success('查看数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/lecture-vod?id=' + event.currentTarget.value)
  }

  //点击了编辑按钮
  const onEditBtnClick = (event:any) => {
    //message.success('编辑数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/oam_video_edit?video_id=' + event.currentTarget.value)
  }

    //点击上传按钮
    const onUploadBtnClick = (event:any) => {
        //message.success('编辑数据' + event.currentTarget.value)
        event.preventDefault()
        window.open('/oam_video_upload')
      }


    // 点击 删除
    const onDeleteBtnClick = (name:string, table_id:number) => {
        const sessionid = Cookies.get("sessionid");
        const queryData = {
            lecture_id : table_id,
            sessionid: sessionid,
            sid: sessionid,
        };
        sendHttpPostRequest(
            'video/api/oam_delete_lecture/',
            queryData,
            queryVideoList
        )
    }


    // 点上架按钮
    const onPublishBtnClick = (table_id:string, statusStr:string) => {
        const sessionid = Cookies.get("sessionid");
        const queryData = {
            lecture_id : table_id,
            status : 1,
            sessionid: sessionid,
            sid: sessionid,
        };
        sendHttpPostRequest(
            'video/api/oam_publish_lecture/',
            queryData,
            queryVideoList
        )
    }
    // 点下架按钮
    const onUnPublishBtnClick = (table_id:string, statusStr:string) => {
        const sessionid = Cookies.get("sessionid");
        const queryData = {
            lecture_id : table_id,
            status : 2,
            sessionid: sessionid,
            sid: sessionid,
        };
        sendHttpPostRequest(
            'video/api/oam_unpublish_lecture/',
            queryData,
            queryVideoList
        )
    }


    // 渲染操作
    const renderActions = (text:any, record:any) => {
        return <>

        <Row justify="start" align="middle" gutter={[8, 5]} >
        <Col style={{width:50}}>
            <Button style={{borderRadius:20,fontSize:12}} size='small' id="lookover"
                    value={record.id} type="default" onClick={onLookOverBtnClick} > 查 看 </Button>
        </Col>
        <Col style={{width:50}}>
            <Button style={{borderRadius:20,fontSize:12}} size='small'
                    id="edit" value={record.id} type="dashed" onClick={onEditBtnClick}> 编 辑 </Button>
        </Col>
        {
        <Col style={{width:50}}> { record.status == "1" ?
            <Button style={{borderRadius:20,fontSize:12}}  size='small' id="puton" value={record.id}
                    type="primary"  onClick={onPublishBtnClick.bind(this, record.id, record.status)}> 上 架 </Button>
            :  <Popconfirm placement="top" title={'确认下架视频"' + record.title + '"吗？'}
                           onConfirm={onUnPublishBtnClick.bind(this, record.id, record.status)}
                           okText="确认" cancelText="取消">
                <Button style={{borderRadius:20,fontSize:12}}  size='small'
                        id="putoff" value={record.id} type="primary"  danger> 下 架 </Button>
                </Popconfirm>}
        </Col>
        }
        {
        <Col style={{width:50}}>
            <Popconfirm placement="top" title={'确认删除视频"' + record.title + '"吗？'}
                        onConfirm={onDeleteBtnClick.bind(this, record.title,record.id)} okText="确认" cancelText="取消">
                <Button style={{borderRadius:20,fontSize:12}} size='small' id="delete" danger value={record.id} > 删 除 </Button>
            </Popconfirm>
        </Col>
        }
        </Row>

        </>
    }

 
  
    //点击了搜索按钮
    const onSearchBtn = (value: string) => {
        page.current = 1;
        queryContent.current = value;
        //queryUserInfo();
    }

    // 表格发生变化
    const onTableChange:any = (pagination:any, filters:any, sorter:any, extra: { currentDataSource: [], action: any })=> {
        if (sorter.order) { //如果选择了排序列
            //order.current = sorter.order;
            //order_by.current = sorter.field;
        }
        if (filters.sex) { //如果选择了过滤列
            //sexFilters.current = filters.sex;
        } else {
            //sexFilters.current = [];
        }
        if (filters.channel_name) {
            channelFilters.current = filters.channel_name.map(element=> {
                return channelMap.get(element);
            });
        } else {
            channelFilters.current = [];
        }
        page.current = 1;
        //queryUserInfo();
    }

    // 表格列
    const cols: any = [
        {
            title: "标题",
            dataIndex: "title",
            key: "title",
            width: 150,
            align: 'left',
            ellipsis: true,
            //sortDirections: ['descend', 'ascend'],
        },
        {
            title: "时长",
            dataIndex: "duration",
            key: "duration",
            width: 80,
            align: 'center',
        },
        {
            title: "观看次数",
            dataIndex: "view_cnt",
            key: "view_cnt",
            width: 80,
            align: 'center',
        },
        {
            title: "上传时间",
            dataIndex: "update_time",
            key: "update_time",
            width: 120,
            align: 'center',
            sorter: true,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: "状态",
            dataIndex: "status_str",
            key: "status_str",
            width: 80,
            align: 'center',
        },
        {
            title: "操作",
            dataIndex: "actions",
            key: "actions",
            width: 160,
            ellipsis: false,
            align: 'center',
            render: renderActions ,
        },
    ]

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <OAMSider keys={"34"} openKeys={["sub-course"]} ></OAMSider>
            <Layout style={{backgroundColor:'#f9f9f9'}}>
                <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:400,margin:30 ,paddingTop:20}}>
                
                    <div style={{paddingLeft:30,paddingRight:30}}>
                    <Row align="middle"  gutter={16}>

                        <Col flex='80px'>
                            <Statistic title="视频总数" value={totalCount} />
                        </Col>
                        <Col flex='80px'>
                            <Statistic title="已上线" value={onlineCount} />
                        </Col>
                        <Col flex='250px'>
                            <Search
                                placeholder="搜索视频"
                                style={{ width: 250 }}
                                enterButton={true}
                                onSearch={onSearchBtn}
                            />

                        </Col>
                        <Col flex='auto' style={{textAlign:'right'}}>
                            <Button style={{borderRadius:20}} type={'primary'} onClick={onUploadBtnClick}>+上传视频</Button>
                        </Col>

                    </Row>
                      

                    <div className={idataCourseTableStyles.tableWrapper}>
                    <ConfigProvider locale={zhCN}>
                        <Table
                            dataSource={videoResult}
                            columns={cols}
                            rowKey={record => record.id}
                            pagination={false}
                           // bordered={true}
                            onChange={onTableChange}
                        />
                    </ConfigProvider>
                    </div>


                        <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:30,paddingTop:30}} className={"css.pagination"} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={resultSum}
                                    current={page.current}
                                    defaultPageSize={20}
                                    hideOnSinglePage={true}
                                    onChange={onPageChange}
                                    showQuickJumper={true}
                                    showTotal={total => `共 ${total} 视频`}
                                    pageSizeOptions={["3","20","30","50","100"]}
                                />
                            </div>
                        </ConfigProvider>
                    </div>
                </Content>
            </Layout>
        </Layout>

    )

}

export default OAMVideoList


